import { useEffect, useRef } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { message } from 'antd';

import { useAuthStore } from '@/stores/authStore';

/**
 * RBAC 配置中心 admin-only 路由守卫。
 *
 * 嵌于 RequireAuth 之内：到达本组件时 user 已认证（RequireAuth 保证）。
 * 仅做 role 判定——非 admin → AntD message「需管理员权限」+ redirect /overview。
 * 复用 RequireAuth 同源 authStore.user.role，0 新通知/鉴权框架。
 */
export default function RequireAdmin() {
  const user = useAuthStore((s) => s.user);
  const isAdmin = user?.role === 'admin';
  const warned = useRef(false);

  useEffect(() => {
    if (!isAdmin && !warned.current) {
      warned.current = true;
      message.warning('需管理员权限');
    }
  }, [isAdmin]);

  if (!isAdmin) {
    return <Navigate to="/overview" replace />;
  }

  return <Outlet />;
}
